export default "__VITE_ASSET__6070a9cf__"